import Vue from 'vue';

export default {
    loadMainNav(state) {
        Vue.set(state.layout, 'mainNav', null);
        Vue.set(state.questions, 'mainNavIsLoading', true);
    },
    loadMainNavSuccess(state, payload) {
        Vue.set(state.layout, 'mainNav', payload);
        Vue.set(state.questions, 'mainNavIsLoading', false);
    },
    loadMainNavError(state, payload) {
        Vue.set(state.layout, 'mainNavhasError', payload);
        Vue.set(state.questions, 'mainNavIsLoading', false);
    },

    loadFooterNav(state) {
        Vue.set(state.layout, 'footerNav', null);
        Vue.set(state.questions, 'footerNavIsLoading', true);
    },
    loadFooterNavSuccess(state, payload) {
        Vue.set(state.layout, 'footerNav', payload);
        Vue.set(state.questions, 'footerNavIsLoading', false);
    },
    loadFooterNavError(state, payload) {
        Vue.set(state.layout, 'footerNavHasError', payload);
        Vue.set(state.questions, 'footerNavIsLoading', false);
    },

    setSiteHeaderMode(state, payload) {
        Vue.set(state.layout, 'siteHeaderMode', payload);
    },
    setSiteFooterVisability(state, payload) {
        Vue.set(state.layout, 'siteFooterVisability', payload);
    },
    
};
